export default "/telegram.ec57a7bd-085075.png";